import { render, staticRenderFns } from "./DocumentFragment.vue?vue&type=template&id=71489601&scoped=true"
import script from "./DocumentFragment.vue?vue&type=script&lang=ts"
export * from "./DocumentFragment.vue?vue&type=script&lang=ts"
import style0 from "./DocumentFragment.vue?vue&type=style&index=0&id=71489601&prod&lang=scss&scoped=true"
import style1 from "./DocumentFragment.vue?vue&type=style&index=1&id=71489601&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71489601",
  null
  
)

export default component.exports